<template>
	<div class="intro">
		<div></div>
	</div>
</template>

<script>
	export default {
  name: 'Intro',
  data (){
    return {}
  }, methods: {

  },
  created: function (){
  	
  }
}
</script>

<style>
	.intro{
	    width: 100%;
	    height: 100%;
	    background-size: cover;
	    position: absolute;
	    z-index: 999;
	    top: 0;
	    opacity: 1;
		animation-name: introOut;
		animation-delay: 6s;
  		animation-duration: 1s;
	}

	.intro > div{
		background: #ff9933 url('../ui-assets/intro.gif') center center;
		background-size: cover;
		position: absolute;
		left: 0;
		width: 100%;
		height: 100%;
	}

	@keyframes introOut {
	  from {opacity: 1;}
	  to {opacity: 0}
	}

@media screen and (orientation: portrait) and (max-width: 1080px)  {

	.intro > div{
		background: #ff9933 url('../ui-assets/intro-port.gif') center center;
		background-size: 100% auto;
	}
}

</style>
